export function configuredMapStyle(
  provider: 'NONE' | 'OPENFREEMAP' | 'CUSTOM_STYLE',
  styleUrl?: string,
  deploymentStyleUrl?: string
): string | undefined {
  const candidate = provider === 'CUSTOM_STYLE' ? styleUrl : deploymentStyleUrl;
  if (!candidate) return undefined;
  try {
    const url = new URL(candidate);
    if (
      url.username ||
      url.password ||
      url.hostname === 'tile.openstreetmap.org' ||
      url.hostname.endsWith('.tile.openstreetmap.org')
    )
      return undefined;
    return url.protocol === 'https:' ? url.toString() : undefined;
  } catch {
    return undefined;
  }
}
